import { Parcel } from "@/domain/parcels/parcel"

export const ParcelContractData = ({ parcel }: { parcel: Parcel }) => (
  <div className="bg-emerald-50/50 border border-emerald-100 rounded-lg p-3 mt-4 max-w-md">
    <span className="text-xs font-semibold text-emerald-800 uppercase tracking-wider block mb-2">Datos de Parcela</span>
    <div className="flex items-center justify-between text-sm font-mono text-emerald-900 bg-white rounded border border-emerald-100 p-2">
      <div className="text-center px-2">
        <div className="text-[11px] text-emerald-600 mb-0.5">Sección</div>
        <div>{parcel.section}</div>
      </div>
      <div className="w-px h-6 bg-emerald-200"></div>
      <div className="text-center px-2">
        <div className="text-[11px] text-emerald-600 mb-0.5">Fila</div>
        <div>{parcel.fila}</div>
      </div>
      <div className="w-px h-6 bg-emerald-200"></div>
      <div className="text-center px-2">
        <div className="text-[11px] text-emerald-600 mb-0.5">N° de Parcela</div>
        <div>{parcel.parcela}</div>
      </div>
    </div>
  </div>
)